<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477 336.193">
    <g transform="translate(803)">
      <path d="M-326,0v231.6c-27.2,3.8-54.8,4.7-82.3,2.5c-48.9-4.1-88.3-18.3-117.4-34.1
        c-58.5-31.8-59.4-59.6-153.1-72c-71.2-12-96.9-56.5-109.6-83.1C-793.9,39-801.5,6.3-803,0H-326z" fill="#F0DFD3" />
    </g>
    <g transform="translate(996.957)">
      <g transform="translate(0)">
        <path d="M-520,334.1v2.1h-0.5c-10,0-20-1.1-29.9-3.2c-56.8-11.9-105.4-50-126.7-99.3c-4.9-11.4-8.5-23.4-11.9-35.1
          c-4.6-15.5-9.3-31.4-17.1-45.7c-12.2-22.4-31.5-40-51.9-57.6l-1.1-0.9c-9.6-8.3-19.5-16.9-27.2-27.2
          c-14.1-18.9-19.3-43.8-15.7-67.1h2.1c-3.7,22.8,1.5,47.3,15.3,65.8c7.6,10.2,17.4,18.7,26.9,26.9l1.1,0.9
          c20.5,17.7,39.9,35.5,52.3,58.2c7.9,14.5,12.7,30.6,17.3,46.2c3.4,11.6,7,23.6,11.9,34.9c21,48.7,69,86.3,125.2,98.1
          c9.6,2.1,19.4,3.1,29.2,3.2C-520.4,334.1-520.2,334.1-520,334.1z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgForm2'
}
</script>
